module.exports = __webpack_public_path__ + "img/iconDevice-GreenDark.c0a430ad.svg";